module.exports = __webpack_public_path__ + "img/backup-lead-directory-icon.8bf0216a.svg";